export default "__VITE_ASSET__cIWFjb_F__"